<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Análises — Minhas análises: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  e
        strong  abrir
        |  as análises atribuídas a você, no menu
        strong  Análises → Minhas análises
        | . As ações de atendimento (Concluir, Reanálise e Reabrir OS-m) ficam no manual de Atendimento.

      .toast.toast-primary
        | A listagem exige a permissão
        strong  Ordem serviços → Análise → Minhas análises → Listar
        | .

      h5.h5 1. Abrir Minhas análises
      ol
        li No menu lateral, clique em
          strong  Análises
          | .
        li Clique em
          strong  Minhas análises
          | .
      p O badge no menu indica quantas análises estão aguardando. A lista carrega ao abrir a tela.

      h5.h5 2. Filtros e listagem
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Minhas análises com cards")
      p Por padrão, a lista filtra situação
        strong  Aguardando
        | . Filtros comuns:
      ul
        li
          strong OS-m Número
          |  e
          strong  OS-m Ano
        li
          strong Situação
        li Outros (cadastro, datas, protocolo, assunto etc.) pela engrenagem de filtros
      ol
        li Ajuste os critérios desejados.
        li Clique na
          strong  lupa
          |  para aplicar a busca.
      p Cada análise aparece em um
        strong  card
        |  com analista, situação, assunto, número/ano da OS-m, datas, protocolo, contribuinte e cadastro.

      h5.h5 3. Abrir a análise
      ol
        li No rodapé do card, clique em
          strong  Exibir
          | .
        li O sistema abre o detalhe da análise.

      .toast.toast-primary
        | A exibição exige a permissão
        strong  Ordem serviços → Análise → Minhas análises → Exibir
        | .

      h5.h5 4. Tela de exibição
      figure.manual-figure
        img(:src="imgShow" alt="Exibição de uma análise em Minhas análises")
      p No topo ficam assunto, situação, número da OS-m, datas e analista. Abaixo:
      ul
        li
          strong Eventos da análise
          |  — histórico de encaminhamentos e resultados
        li
          strong Mais informações da OS-m
          |  — protocolo, situação, responsáveis e cadastro
        li
          strong Ver OS-m
          |  — abre a Ordem de Serviço vinculada
        li
          strong Checklist
          |  e
          strong  Resultado
          |  — respostas e referências da vistoria
        li
          strong Imprimir
          |  — versão para impressão
      p Quando a situação for
        strong  Aguardando
        | , aparecem os botões de atendimento (ver manual
        strong  Minhas análises: Atendimento
        | ).

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/10-analises-minhas-lista.png"),
      imgShow: require("@/assets/manuais/10a-analises-minhas-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
